import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktCampaignProcessingQueueContainerModel } from '../../../../../../models';
import { ApiVisa } from '../../shared';

@Injectable({
  providedIn: 'root',
})
export class DgMktCampaignProcessingQueueService extends BaseApiTemplateService<DgMktCampaignProcessingQueueContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'campaigns/execute';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaigns/execute';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaigns/execute';
    this.httpClient = http;
  }

  executeCampaignByGuid(guid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/${guid}`;
    }

    const httpOptions = this.getHttpHeader(apiVisa);
    httpOptions.headers.append('Content-Type', 'application/json');

    return this.httpClient.get(this.apiUrl, httpOptions);
  }
}
